import React from 'react';

import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { styled, useTheme } from "@mui/material/styles";
import Box from "@mui/material/Box";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
// import "../MiniDrawer/MiniDrawer.css";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import InboxIcon from "@mui/icons-material/MoveToInbox";
import MailIcon from "@mui/icons-material/Mail";
import logo from "../.././images/Clogo.png";

import OperationIcon from "@mui/icons-material/ManageAccounts";
// import SalesIcon from "@mui/icons-material/RecordVoiceOver";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import { IoMdLogOut } from "react-icons/io";

// import SalesNewIcon from "../../../src/Icons/salesIcon.png";
// import CarryMyPet from "../../../src/Icons/ERPSidebarimg.png";

// import OperationsNewIcon from "../../../src/Icons/OperationIcon.png";
// import MarketingNewIcon from "../../../src/Icons/MarketingIcon.png";
// import ITNewIcon from "../../../src/Icons/itIcon.png";
// import HRNewIcon from "../../../src/Icons/HrIcon.png";
// import AccountsNewIcon from "../../../src/Icons/accountIcon.png";
// import MastersNewIcon from "../../../src/Icons/MasterIcon.png";
// import Login from "../../../src/pages/login/login";
import shadows from "@mui/material/styles/shadows";

const drawerWidth = 240;

const openedMixin = (theme) => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: "hidden",
});

const closedMixin = (theme) => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(8)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(["width", "margin"], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": openedMixin(theme),
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": closedMixin(theme),
  }),
}));



const CustomerNavbar = () => {




    const theme = useTheme();
    const [open, setOpen] = useState(false);
    const [mastersOpen, setMastersOpen] = React.useState(false); // State for the "Masters" list
    const [salesOpen, setSalesOpen] = React.useState(false); // State for the "Sales" list
    const navigate = useNavigate(); // State for the Navigation list
    const [isInventoryOpen, setInventoryOpen] = useState(false);
    const [isChargesOpen, setChargesOpen] = useState(false);
    const [isRegionOpen, setRegionOpen] = useState(false);
  
    // const [name, setName] = useState("");
    // const [designation, setDesignation] = useState("");
  
    const name = localStorage.getItem("name");
    const designation = localStorage.getItem("designation");
    const isAdmin = localStorage.getItem("isAdmin");
    const Dept_ID = localStorage.getItem("Dept_ID");
  
    const handleChargesClick = () => {
      setChargesOpen(!isChargesOpen);
    };
  
    const handleInventoryClick = () => {
      setInventoryOpen(!isInventoryOpen);
    };
  
    const handleRegionClick = () => {
      setRegionOpen(!isRegionOpen);
    };
  
    const handleDrawerOpen = () => {
      setOpen(true);
    };
  
    const handleDrawerClose = () => {
      setMastersOpen(false);
      setSalesOpen(false);
      setOpen(false);
    };
  
    const handleMastersOpen = () => {
      if (open === true) setMastersOpen(!mastersOpen);
    };
  
    const handleSalesOpen = () => {
      if (open === true) setSalesOpen(!salesOpen);
    };
  
    function SignOut() {
      localStorage.removeItem("token");
     
      navigate("/Login-Customer");
    }
  
    function ChnagePassword() {
      navigate("/ChangePassword");
    }
  
    // ..........................................
  
    const [dropdownOpen, setDropdownOpen] = useState(false);
  
    const toggleDropdown = () => {
      setDropdownOpen(!dropdownOpen);
    };
  



  return (
    
    <Box sx={{ display: "flex" }}>
    <CssBaseline />
    <AppBar position="fixed" open={open}>
      <Toolbar
        sx={{
          background: "linear-gradient(to right, #F15843, #A3519F, #5B489D)",
        }}
      >
        {/* <FileDownloadOutlinedIcon
          className="rotate-icon"
          color="inherit"
          aria-label="open drawer"
          onClick={handleDrawerOpen}
          edge="start"
          sx={{
            marginRight: 5,
            ...(open && { display: "none" }),
          }}
        >
          <MenuIcon />
        </FileDownloadOutlinedIcon> */}
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            width: "100%",
          }}
        >
          <Typography
            variant="h6"
            noWrap
            component="div"
            style={{ paddingTop: "17px", cursor: "pointer" }}

            onClick={() => navigate("/Dashboard")}
          >
            

<img src={logo} alt=""/>


          </Typography>

          {/* ..................................... */}
          <div style={{ display: "flex", alignItems: "center" }}>
            {/* <div
              style={{
                fontWeight: "bold",
                fontSize: "20px",
                marginRight: "10px",
              }}
            >
              <NotificationsNoneIcon className="Notificationicon" />
            </div> */}
            <div
              style={{
                borderRight: "1px solid #fff",
                height: "73px",
                marginRight: "10px",
                color: "white",
              }}
            ></div>
            <div
              style={{
                fontWeight: "bold",
                fontSize: "20px",
                marginRight: "10px",
              }}
            >
              <PersonOutlineOutlinedIcon className="PersonOutlineOutlinedIcon" />
            </div>
            <div style={{ position: "relative" }}>
              <a
                style={{ cursor: "pointer", marginLeft: "10px" }}
                onClick={toggleDropdown}
              >
                {/* <h4 style={{fontSize: '1rem'}}>Ankur Shing</h4> */}
                <div style={{ paddingBottom: "1rem" }}>
                  <p style={{ fontSize: "14px", marginBottom: "-8px" }}>
                    Welcome {name}
                  </p>
                  <span style={{ fontSize: "9px" }}>{designation}</span>
                </div>
              </a>
              {dropdownOpen && (
                <ul
                  style={{
                    position: "absolute",
                    top: "100%",
                    right: 0,
                    background: "#fff",
                    listStyle: "none",
                    margin: 0,
                    zIndex: 1,
                    width: "12rem",
                    padding: "19px",
                    borderRadius: "13px",
                    boxShadow: "0 1px 8px rgba(0, 0, 0, 0.25)",
                  }}
                >
                  <li
                    style={{
                      padding: "8px",
                      cursor: "pointer",
                      color: "black",
                    }}
                  >
                    <PersonOutlineOutlinedIcon className="PersonOutlineOutlinedIcon" />
                    Profile
                  </li>
                  <li
                    style={{
                      padding: "8px",
                      cursor: "pointer",
                      color: "black",
                    }}
                    onClick={() => ChnagePassword()}
                  >
                    Change Password
                  </li>

                  <div
                    style={{
                      border: "1px solid #000",
                      height: "2px",
                      width: "152px",
                      marginRight: "10px",
                      color: "balck",
                    }}
                  ></div>

                  <li
                    style={{
                      padding: "8px",
                      cursor: "pointer",
                      color: "black",
                    }}
                    onClick={() => SignOut()}
                  >
                    <IoMdLogOut />
                    Sign Out
                  </li>
                </ul>
              )}
            </div>
          </div>

          {/* ....................... */}
        </div>
      </Toolbar>
    </AppBar>

    {/*  */}
    </Box>


    
  )
}

export default CustomerNavbar;